import React, { useContext, useEffect } from 'react';
import { parse, stringify } from 'querystring';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { OneloginContext } from '../../../utils/OneLogin/context';
import { cognito_authority, cognito_client_id, cognito_redirect_uri, cognito_verifier } from '../utils';
import Axios from 'axios';
import { loginUser } from '../../../redux/actions/user';

export const CognitoFlow = (props) => {
  const location = useLocation();
  const params = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const { oneloginSec } = useContext(OneloginContext);
  const urlParams = new URLSearchParams(location.search);
  const code = urlParams.get('code');
  const cognitoResponse = location.pathname.split('=')[1];

  useEffect(() => {
    const exchange = async (params) => {
      const response = await fetch(`${cognito_authority}/oauth2/token`, {
        method: 'post',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: stringify({
          grant_type: 'authorization_code',
          code,
          redirect_uri: cognito_redirect_uri,
          client_id: cognito_client_id,
          // code_verifier: '4ffc114e504047deb57f3e8dfeeda70d93bbfb6d8f0444c9b9b147f3872dbde24f58cbe3047d49ce9b5194fe80e0905a',
        }),
        //   credentials: 'include',
      })
        .then(async (res) => {
          let data = await res.json();
          handleLogin(data)
        })
        .catch((err) => {
          console.log('Error: /frontend/src/pages/LoginPage/components/CognitoFlow//useEffect', err);
        });
    };
    if (code) {
      exchange({
        code,
        redirect_uri: cognito_redirect_uri,
        client_id: cognito_client_id,
      });
    }
  }, [code]);

  const handleLogin = async (json) => {
    //    if(cognitoResponse.state !== oneloginSec.state){
    // console.log('crypto mismatch')
    // console.log('json: ', json);
    // history.push('/login');
    //return null
    //    }
    const response = await fetch(`${(window as any)._env_.REACT_APP_SERVER}/auth/onelogin/cognitoweb`, {
        method: 'post',
        headers: { 'Content-Type': 'application/json'},
        body: JSON.stringify(json),
        credentials: 'include'
    })

    if(response.ok){

        const data =await response.json()
        if(data.accessToken){
            dispatch(loginUser(data))
            handleRedirect()
        }
    }
  };

  const handleRedirect = () => {
    if (location.state !== undefined) {
      if ((location.state as any).from !== undefined) {
        history.push((location.state as any).from.pathname);
      } else {
        history.push('/');
      }
    } else {
      history.push('/');
    }
  };

  handleLogin(cognitoResponse);
  return null;
};
